<template>
    <div class="attempt-icon">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 62.61 62.61"><defs><linearGradient id="linear-gradient" y1="31.3" x2="62.61" y2="31.3" gradientUnits="userSpaceOnUse"><stop offset="0.01" stop-color="#ff0062"/><stop offset="1" stop-color="#ff64a3"/></linearGradient><linearGradient id="linear-gradient-2" x1="14.89" y1="16.27" x2="25.93" y2="16.27" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#fff"/></linearGradient><linearGradient id="linear-gradient-3" x1="31.31" y1="17.29" x2="42.62" y2="17.29" xlink:href="#linear-gradient-2"/></defs><g id="Camada_2" data-name="Camada 2"><g id="Layer_1" data-name="Layer 1"><circle class="cls-1" cx="31.3" cy="31.3" r="31.3"/><path class="cls-2" d="M2.85,34.15a31.3,31.3,0,0,1,52-23.51A31.3,31.3,0,1,0,10.64,54.81,31.16,31.16,0,0,1,2.85,34.15Z"/><polygon class="cls-3" points="49.9 26.55 42.71 19.36 33.48 28.59 24.25 19.36 17.07 26.55 26.29 35.78 17.07 45 24.25 52.19 33.48 42.97 42.71 52.19 49.9 45 40.67 35.78 49.9 26.55"/><polygon class="cls-4" points="46.51 39.04 39.68 32.22 48.91 22.99 47.72 19.86 46.25 20.34 41.72 15.8 32.49 25.03 23.27 15.8 19.21 19.86 14.89 19.86 16.08 22.99 25.3 32.22 18.05 39.48 14.89 38.31 16.08 41.44 23.27 48.63 32.49 39.41 41.72 48.63 48.91 41.44 47.72 38.31 46.51 39.04"/><polygon class="cls-5" points="47.72 19.86 40.53 12.67 31.31 21.9 22.08 12.67 14.89 19.86 24.12 29.09 14.89 38.31 22.08 45.5 31.31 36.28 40.53 45.5 47.72 38.31 38.5 29.09 47.72 19.86"/><polygon class="cls-6" points="14.89 19.86 22.08 12.67 25.93 16.52 22.63 14.54 14.89 19.86"/><polygon class="cls-7" points="31.31 21.9 40.53 12.67 42.62 14.76 40.74 14.44 31.31 21.9"/></g></g></svg>
    </div>
</template>

<script>

export default {
    name: 'Attempt4',
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }
}
</script>

<style lang="scss" scoped>
svg{
    font-weight: 700;
    height: 25px;
}
// .cls-1{fill:url(#linear-gradient);}
.cls-1{fill:#ff0062}
.cls-2{fill:#9b0047;}.cls-3{opacity:0.15;}.cls-4{fill:#b7b7b7;}.cls-5{fill:#fff;}.cls-6,.cls-7{opacity:0.2;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}
</style>
